export default "__VITE_ASSET__CgVJmGRL__"